import React from "react";
import { InlineWidget } from "react-calendly";
import { Calendar } from "lucide-react";

/**
 * Reusable Calendly embed component
 * @param {string} calendlyUrl - Your Calendly booking URL
 * @param {string} title - Section title
 * @param {string} description - Section description
 * @param {number} height - Widget height in pixels (default: 700)
 */
export default function CalendlyEmbed({ 
  calendlyUrl, 
  title = "Schedule an Appointment",
  description = "Choose a time that works for you",
  height = 700 
}) {
  
  if (!calendlyUrl) {
    return (
      <div className="bg-yellow-900/20 border border-yellow-500/30 rounded-xl p-6">
        <div className="flex items-start gap-3">
          <Calendar className="w-6 h-6 text-yellow-400 mt-1" />
          <div>
            <h3 className="text-lg font-bold text-yellow-300 mb-2">
              Calendly Setup Required
            </h3>
            <p className="text-yellow-200/80 text-sm mb-3">
              To enable booking, add your Calendly URL to the environment configuration.
            </p>
            <div className="bg-black/40 rounded-lg p-3 font-mono text-xs text-gray-300">
              <p>Add to <code className="text-purple-400">/app/frontend/.env</code>:</p>
              <p className="mt-2 text-green-400">
                REACT_APP_CALENDLY_VIP_URL=https://calendly.com/your-name/vip-booking
              </p>
              <p className="text-green-400">
                REACT_APP_CALENDLY_COLLAB_URL=https://calendly.com/your-name/collaboration
              </p>
            </div>
            <p className="text-xs text-yellow-200/60 mt-3">
              Get your booking URL from <a href="https://calendly.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-yellow-300">calendly.com</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {(title || description) && (
        <div className="text-center">
          {title && (
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center justify-center gap-2">
              <Calendar className="w-6 h-6 text-purple-400" />
              {title}
            </h3>
          )}
          {description && (
            <p className="text-gray-400">{description}</p>
          )}
        </div>
      )}
      
      <div 
        className="rounded-xl overflow-hidden border border-white/10" 
        style={{ minHeight: `${height}px` }}
      >
        <InlineWidget
          url={calendlyUrl}
          styles={{
            height: `${height}px`,
            minWidth: "320px",
            width: "100%"
          }}
          pageSettings={{
            backgroundColor: "1a1a1a",
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: "a855f7",
            textColor: "ffffff",
            hideGdprBanner: true
          }}
        />
      </div>
    </div>
  );
}
